import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedCompComponent } from './shared-comp/shared-comp.component';
import { MsgsToUserComponent } from './msgs-to-user/msgs-to-user.component';

// import { GetDataNgrxSharedSampleComponent } from './get-data-ngrx-shared-sample/get-data-ngrx-shared-sample.component';
//import myStrings from './shared/utilities';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PrettyPrintJsonPipe } from './shared/pipes/pretty-print-json.pipe';

import { AllMaterialModule, AllPrimeNgModule } from '@nxt/shared-modules';
import { ConfigService } from './shared/services/config-service.service';
import { SharedHandlerComponent } from './shared-handler/shared-handler.component';
import { SafePipe } from './shared/pipes/safe-pipe.pipe';
import { BaseUrlChangeDialogComponent } from './base-url-change-dialog/base-url-change-dialog.component';
import { SharedRecaptchaComponent } from './shared-recaptcha/shared-recaptcha.component';
import { RecaptchaModule, ReCaptchaV3Service, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { SharedCaptchaV2Component } from './shared-recaptcha/componenets/shared-captcha-v2/shared-captcha-v2.component';

@NgModule({
  declarations: [
    SharedCompComponent,
    MsgsToUserComponent,
    PrettyPrintJsonPipe,
    SharedHandlerComponent,
    SafePipe,
    BaseUrlChangeDialogComponent,
    SharedRecaptchaComponent,
    SharedCaptchaV2Component,
    // GetDataNgrxSharedSampleComponent,
  ],
  imports: [
    //BrowserAnimationsModule,
    CommonModule,
    RouterModule.forChild([
      /* {path: '', pathMatch: 'full', component: InsertYourComponentHere} */
    ]),
    AllMaterialModule,
    AllPrimeNgModule,
    RecaptchaModule
    //ConfigService,
    //PubSubModule.forRoot() // Initiate Pubsub module
  ],
  exports: [
    SharedCompComponent,
    // myStrings
    MsgsToUserComponent,
    AllMaterialModule,
    AllPrimeNgModule,
    PrettyPrintJsonPipe,
    //ConfigService
    // GetDataNgrxSharedSampleComponent,
    SharedHandlerComponent,
    BaseUrlChangeDialogComponent,
    SharedRecaptchaComponent,
  ],
  providers: [
    ReCaptchaV3Service,
    //https://www.c-sharpcorner.com/article/implementing-google-recaptcha-v3-in-angular-14/
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: '6LdWnDclAAAAAClGlIJtFTyHI4nRzpJCTWw-kFXJ',
    },
  ],
})
export class SharedLib1Module {}
